import { CLUSTER_OTHER_ID } from '../constants.js';
import {
  type LeafNode,
  type ClusterNode,
  isLeaf,
  isCluster,
} from '../types/guards/node-guards.js';
import type { InternalTreeMapNode } from '../types/internal.js';
import type { NameAccessor } from '../types/treemap.js';

export const getNodeNames = (
  node: LeafNode | ClusterNode,
  nameAccessor: NameAccessor | undefined,
  clusterName: string,
): Set<string> => {
  const nodeName = node.name;
  const parentName = isLeaf(node) && clusterName;
  const isOtherCluster = node.id === CLUSTER_OTHER_ID;

  if (isOtherCluster) {
    return new Set([...(node.aggregatedNodes ?? [])]);
  }
  const names = [nodeName];
  parentName && names.push(parentName);

  const leafNodes = isCluster(node) ? node.children ?? [] : [node];

  const leafNames =
    nameAccessor && typeof nameAccessor === 'string'
      ? leafNodes.map((leaf: InternalTreeMapNode) => leaf[nameAccessor])
      : [];

  const aggregatedNodeNames = leafNodes.flatMap(
    (leaf: InternalTreeMapNode) => leaf.aggregatedNodes ?? [],
  );

  return new Set([
    ...names,
    ...(leafNames as string[]),
    ...aggregatedNodeNames,
  ]);
};
